import React, { Component } from 'react'
import autobind from 'autobind-decorator'

import axios from 'axios'
import Modal from 'react-modal'

import FaLightbulb from 'react-icons/fa/lightbulb-o'
import FaClose from 'react-icons/fa/times-circle'

import './Campaigns.css'

@autobind
class Campaigns extends Component {
  constructor (props) {
    super(props)
    this.state = {campaigns: [], collapsed: [], showModal: true}
  }

  componentWillMount () {
    Modal.setAppElement('body')
  }

  componentDidMount () {
    axios.get('/campaigns.json').then(({data: {data}}) => this.setState({campaigns: data})).catch(() => {})
    try {
      let collapsed = JSON.parse(localStorage.getItem('campaigns')).collapsed
      if (collapsed.length) {
        this.setState({collapsed})
      }
    } catch (e) {
      localStorage.removeItem('campaigns')
    }
  }

  handleOpenModal () {
    this.setState({showModal: true})
  }

  handleCloseModal () {
    this.setState({showModal: false})
  }

  collapse (id) {
    return () => this.setState({collapsed: [...this.state.collapsed, id]}, () =>
      localStorage.setItem('campaigns', JSON.stringify({collapsed: this.state.collapsed})))
  }

  render () {
    let campaignsTopbar = this.state.campaigns.length && this.state.campaigns
      .filter(campaign => this.state.collapsed.indexOf(campaign.id) === -1 && campaign.attributes.campaign_type === 'banner')
      .sort((c1, c2) => c1.attributes.priority - c2.attributes.priority)
      .map(campaign =>
        <div styleName='container' key={campaign.id}>
          <div styleName='message'>
            <FaLightbulb /> <p>{campaign.attributes.title} <a href={campaign.attributes.cta_link} target='_blank' styleName='link'>{campaign.attributes.cta_label}</a></p>
          </div>
          <a styleName='close' onClick={this.collapse(campaign.id)}>Don't show this again <FaClose /></a>
        </div>
      )
    let campaignsModal = this.state.campaigns.length && this.state.campaigns
      .filter(campaign => this.state.collapsed.indexOf(campaign.id) === -1 && campaign.attributes.campaign_type === 'modal')
      .sort((c1, c2) => c1.attributes.priority - c2.attributes.priority)
      .map(campaign =>
        <Modal key={campaign.id} isOpen={this.state.showModal} contentLabel={campaign.attributes.title} onRequestClose={this.handleCloseModal} overlayClassName='modal' className='modal-dialog modal-dialog--medium'>
          <div className='modal-content modal-content--overflow'>
            <div styleName='visual' style={{backgroundImage: `url(${campaign.attributes.url})`}} />
            <div className='modal-body text-center'>
              <h2 className='modal-title'>{campaign.attributes.title}</h2>
              <p>{campaign.attributes.description}</p>
              <div>
                <a href='#' onClick={this.handleCloseModal} className='btn btn-default' styleName='button'>Remind me later</a>
                &nbsp;
                <a href={campaign.attributes.cta_link} target='_blank' onClick={this.handleCloseModal} className='btn btn-primary'>{campaign.attributes.cta_label}</a>
              </div>
              <div>
                <a onClick={this.collapse(campaign.id)} className='btn btn-link'>Don't show this again</a>
              </div>
            </div>
          </div>
        </Modal>
      )
    return (
      <div>
        {campaignsTopbar || null}
        {campaignsModal || null}
      </div>
    )
  }
}

export default Campaigns



// WEBPACK FOOTER //
// ./components/search/Campaigns.js